import React, { useState, useEffect } from "react";
import { FaArrowUp, FaWhatsapp } from "react-icons/fa6";
import "./FloatingWidgets.css";
import LanguageSelector from "../language/LanguageSelector";
import { useHomeContext } from "../../context/Home_context";

const FloatingWidgets = () => {
  const { current_contact_data, GetCurrentContact } = useHomeContext();
  const [showBackToTop, setShowBackToTop] = useState(false);



  useEffect(() => {
    const handleScroll = () => {
      // Show back to top button after scrolling past hero section (approx 450px)
      if (window.scrollY > 450) {
        setShowBackToTop(true);
      } else {
        setShowBackToTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const rawWhatsapp =
    current_contact_data?.whatsapp_no ||
    current_contact_data?.domestic_mobile1 ||
    "917203040408";

  const cleanDigits = String(rawWhatsapp).replace(/\D/g, "");
  const whatsappNumber =
    cleanDigits.length === 10 ? `91${cleanDigits}` : cleanDigits;

  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=Hello%20Bharat%20Buildcon%20Team%2C%20I%20have%20an%20inquiry.`;

  return (
    <>
      {/* Global Multi-Language Selector Widget */}
      <LanguageSelector />

      <div className="floating-widgets-stack">
        {/* Persistent WhatsApp Floating Button */}
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="floating-btn whatsapp-btn"
          aria-label="Chat on WhatsApp"
          title="Chat on WhatsApp"
        >
          <FaWhatsapp className="btn-icon" />
        </a>

        {/* Back To Top Floating Button (Visible only after Hero Section) */}
        <button
          type="button"
          className={`floating-btn back-to-top-btn ${showBackToTop ? "visible" : ""}`}
          onClick={scrollToTop}
          aria-label="Back to Top"
          title="Back to Top"
        >
          <FaArrowUp className="btn-icon" />
        </button>
      </div>
    </>
  );
};

export default FloatingWidgets;
